import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CreditData, InfoBorrower, DocumentsModel, CotitularModel, UsersModel, FinancingModel } from 'src/app/core';
import { getCodigoId } from 'src/app/core/extensions/financiing-code.extensions';
import { AffiliateService } from 'src/app/core/services/affiliate/affiliate.service';
import { BorrowerService } from 'src/app/core/services/borrower/borrower.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { SharedModule } from 'src/app/shared';
import { BorrowerModule } from '../borrower.module';
import { ChildrenService } from 'src/app/core/services/affiliate/children.service';

@Component({
  selector: 'app-docs-borrower',
  templateUrl: './docs-borrower.component.html',
  styleUrl: './docs-borrower.component.scss',
  standalone: false
})
export class DocsBorrowerComponent {

  public creditId: string;
  public creditData!: CreditData;
  public infoBorrower!: InfoBorrower;
  public userDocs: DocumentsModel[];
  public cotitular!: CotitularModel;
  public secondaryReason!: any;
  public secondaryReasons!: any[];
  public userData!: UsersModel;
  public financing!: FinancingModel;
  public activateTitle: boolean = false;
  public financingCode: string = "";
  public statusBorrower!: string
  public affiliateId: string;

  constructor( 
    private route: ActivatedRoute, 
    private borrowerService: BorrowerService,
    private userService: UserService,
    private affiliateService: AffiliateService,
    private childrenService: ChildrenService
    ) { }

  ngOnInit(): void {
    this.affiliateId = sessionStorage.getItem('affiliateId')
    if (this.childrenService.getSelectedChild()) {
    this.affiliateId =  this.childrenService.getSelectedChild()
    }
    this.route.queryParams.subscribe(
      params => {
      this.creditId = params['id'];
      sessionStorage.setItem('idBorrower', this.creditId)
        this.borrowerService.creditData(this.creditId).subscribe(
          res => {
            this.creditData = res;
            this.financingCode = `Financiación ${getCodigoId(this.creditData.tipo, this.creditData.id)}`
            const borrowerPath = this.creditData.infoPrestatario?.split("/");
            const borrowerId = borrowerPath?.[borrowerPath?.length -1]; 
            const userIdPath = this.creditData.user?.split("/");
            const userIdDoc = userIdPath?.[userIdPath?.length -1];
            sessionStorage.setItem('userBorrowerId', userIdDoc)
            if(this.creditData.cotitular){
              const cotitularIdPath = res.cotitular?.split("/");
              const cotitularId = cotitularIdPath?.[cotitularIdPath?.length -1];
              this.borrowerService.getCotitular(cotitularId).subscribe(
                res => {
                  this.cotitular = res
                }
              )
            }
            this.borrowerService.infoBorrowers(borrowerId).subscribe(
              data => {
                this.infoBorrower = data
                this.affiliateService.getSecondaryReason(this.affiliateId).subscribe(
                  data => {
                    this.secondaryReasons = data['hydra:member'];
                    this.setSecondaryReason();         
                  })
                })
            }
          )
          this.userService.getUser(sessionStorage.getItem('userId')).subscribe(
            res => {
              this.userData = res
            }
          )
        })
  }
/*   setSecondaryReason() {
    if (this.creditData.secondaryReason == null) {
      this.secondaryReason = this.secondaryReasons
    } else {)
      this.secondaryReason = this.secondaryReasons.filter(s => {
        return (s['@idSecondaryReason'] == this.creditData.secondaryReason)
      })
    }
  } */
setSecondaryReason() {
  if (this.creditData.secondaryReason) {
    this.borrowerService.followApiLink(this.creditData.secondaryReason).subscribe(
      data => {
        this.secondaryReason = [data];
      }
    );
  } else {
    this.secondaryReason = '';
  }
}
}